module.exports = __webpack_public_path__ + "static/media/uppfattning.cb334fa0.mp3";